import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["cta", "dialog"];

  connect() {
    console.log("Connected to confirm controller");

    this.asked = false;
    this.dialogTarget.style.display = "none";
  }

  ask(event) {
    if (this.asked) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    this.asked = true;
    this.dialogTarget.style.display = "block";
  }

  confirm() {
    this.dialogTarget.style.display = "none";
    this.ctaTarget.click();
  }

  deny() {
    this.asked = false;
    this.dialogTarget.style.display = "none";
  }
}
